import axios from "../../utils/axios";

const BASE_URL = "/vendor-types";

const vendorTypeService = {
  async getAll(params = {}) {
    const response = await axios.get(BASE_URL, { params });
    return response.data;
  },

  async getById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await axios.post(BASE_URL, data);
    return response.data;
  },

  async update(id, data) {
    const response = await axios.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default vendorTypeService;